import { ArtEmpty } from '../../components/ui.tsx';
import { useViewMeta } from '../viewMeta.ts';
import { RemoteView } from './RemoteView.tsx';

/** A view the Control API does not carry yet: the view's own header, then what it is and where it lives today. */
export function AppOnlyView({ blurb }: { blurb: string }) {
  const m = useViewMeta();
  return (
    <RemoteView narrow>
      <ArtEmpty tone={m.tone} icon={m.icon} title={`${m.title} is in the app`}>
        {blurb}. The workbench does not share this view over the relay yet; open it in AI Workbench on the machine itself.
      </ArtEmpty>
    </RemoteView>
  );
}
